import React, { useCallback, useState } from 'react';
import { DropZone, Caption } from '@shopify/polaris';
import { Stack, Thumbnail, TextStyle } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage, injectIntl } from 'react-intl';
import { toast, getTranslatedText } from '@nile/components';

function FileUpload({ limitFileSize }) {
  return (
    <div className="Polaris-DropZone-FileUpload">
      <div className="Polaris-Stack Polaris-Stack--vertical">
        <div className="Polaris-Stack__Item">
          <img
            src={`${envConfig.imageRoot}svg/not-found.svg`}
            style={{ width: '134px' }}
            className="Polaris-DropZone-FileUpload__Image Polaris-DropZone-FileUpload--sizeExtraLarge"
          />
          {limitFileSize && (
            <div>
              <TextStyle variation="subdued">
                <FormattedMessage
                  id="common.upload.file.limit"
                  values={{
                    size: `${limitFileSize}MB`,
                    b: (chunks) => (
                      <TextStyle weight="SemiBold">{chunks}</TextStyle>
                    )
                  }}
                />
              </TextStyle>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ChooseAttachments(props) {
  const [files, setFiles] = useState([]);

  const { limitFileSize = null, intl } = props;

  const checkFileSize = (file) => {
    const valueInBytes = limitFileSize * 1000000;

    return file?.size < valueInBytes;
  };

  const validateFileSize = async (files) => {
    let validatedFiles = [...files];

    validatedFiles = files.filter((file, idx) => {
      if (!checkFileSize(file)) {
        toast(
          'warning',
          getTranslatedText(intl, 'admin.upload.size.max.error', {
            size: `${limitFileSize}MB`
          })
        );
      }

      return checkFileSize(file);
    });

    return validatedFiles;
  };

  const handleDropZoneDrop = useCallback(
    async (_dropFiles, acceptedFiles, _rejectedFiles) => {
      let validatedFiles = [...acceptedFiles];

      if (props.customValidator) {
        validatedFiles = await props.customValidator(acceptedFiles);
      }

      if (limitFileSize) {
        validatedFiles = await validateFileSize(acceptedFiles);
      }

      setFiles((allFiles) => {
        props.updateFiles([...allFiles, ...validatedFiles]);
        return [...allFiles, ...validatedFiles];
      });
    },
    []
  );

  const validImageTypes = ['image/jpeg', 'image/png'];

  const fileUpload = !files.length && (
    <FileUpload limitFileSize={limitFileSize} />
  );
  const uploadedFiles = files.length > 0 && (
    <Stack vertical>
      {files.map((file, index) => (
        <Stack alignment="center" key={`${index}${file.name}`}>
          <Thumbnail
            size="small"
            alt={file.name}
            source={
              validImageTypes.indexOf(file.type) > 0
                ? window.URL.createObjectURL(file)
                : 'https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304'
            }
          />
          <div>
            {file.name} <Caption>{file.size} bytes</Caption>
          </div>
        </Stack>
      ))}
    </Stack>
  );

  return (
    <div className="upload-section">
      <DropZone
        allowMultiple={!props?.singleUpload}
        accept={props.validTypes || ''}
        type={props.type || 'file'}
        onDrop={handleDropZoneDrop}
      >
        {uploadedFiles}
        {fileUpload}
      </DropZone>
    </div>
  );
}

export default injectIntl(ChooseAttachments);
